module.exports = __webpack_public_path__ + "img/tree.c4f63c44.png";